import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Mail, Calendar } from 'lucide-react';

const SupportPage = () => {
  // This URL will be configured per business in settings
  // For now it's a placeholder that Umar will update with his GHL calendar link
  const calendarUrl = null;

  return (
    <div className="space-y-6 animate-fade-in max-w-3xl mx-auto">
      <div className="text-center">
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Book a 1-on-1 with Umar
        </h1>
        <p className="text-slate-500 mt-2 max-w-lg mx-auto">
          Need help with your marketing, campaigns, or getting the most out of your dashboard?
          Book a free support call and we'll get you sorted.
        </p>
      </div>

      {/* Calendar Embed */}
      <Card className="border-0 shadow-sm overflow-hidden">
        <CardContent className="p-0">
          {calendarUrl ? (
            <iframe
              src={calendarUrl}
              width="100%"
              height="650"
              style={{ border: 0 }}
              title="Book a support call"
              loading="lazy"
            />
          ) : (
            <div className="py-16 text-center">
              <Calendar className="w-12 h-12 text-slate-300 mx-auto mb-3" />
              <p className="text-slate-500">Calendar booking coming soon</p>
              <p className="text-sm text-slate-400 mt-1">
                In the meantime, reach out directly using the contact details below
              </p>
            </div>
          )}
        </CardContent>
      </Card>

      {/* Contact Info */}
      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle className="text-base">Get in Touch</CardTitle>
        </CardHeader>
        <CardContent>
          <a
            href="mailto:umarfarooq0151@gmail.com"
            className="flex items-center gap-3 p-4 rounded-xl bg-blue-50 hover:bg-blue-100 transition-colors"
          >
            <Mail className="w-5 h-5 text-blue-500" />
            <div>
              <p className="text-sm font-medium text-slate-900">Email Us</p>
              <p className="text-xs text-slate-500">umarfarooq0151@gmail.com</p>
            </div>
          </a>
        </CardContent>
      </Card>

      {/* FAQ */}
      <Card className="border-0 shadow-sm">
        <CardHeader>
          <CardTitle className="text-base">Frequently Asked Questions</CardTitle>
        </CardHeader>
        <CardContent>
          <Accordion type="single" collapsible className="w-full">
            <AccordionItem value="item-1">
              <AccordionTrigger className="text-sm">How do I add a new student manually?</AccordionTrigger>
              <AccordionContent className="text-sm text-slate-500">
                Go to the Students page and click "Add Student". Fill in their name, phone, email, and
                which course they're interested in. You can then book them for registration from there.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-2">
              <AccordionTrigger className="text-sm">How does the AI follow-up work?</AccordionTrigger>
              <AccordionContent className="text-sm text-slate-500">
                When a lead comes in from your ads and doesn't book a registration slot, our AI system
                automatically sends 3 SMS messages and makes 3 phone calls over 3 days. If the AI can't
                reach them, the lead appears in your Follow-up Queue for a personal call.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-3">
              <AccordionTrigger className="text-sm">How do I mark attendance?</AccordionTrigger>
              <AccordionContent className="text-sm text-slate-500">
                Go to Courses, select the active course, and click "Mark Register". You'll see a list of
                enrolled students — mark each one as Present, Absent, Late, or Excused. You can call
                absent students directly from the attendance page.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="item-4">
              <AccordionTrigger className="text-sm">How do Google reviews get sent?</AccordionTrigger>
              <AccordionContent className="text-sm text-slate-500">
                When you mark a student as "Course Completed" on the Courses page, a Google review
                request is automatically sent to them. You can track whether reviews have been
                received on the Reviews page. If you haven't set up Google reviews yet, book a
                support call with Umar above and we'll get it sorted.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </CardContent>
      </Card>
    </div>
  );
};

export default SupportPage;
